import { alpha } from "@mui/material/styles";

// ----------------------------------------------------------------------

const PRIMARY = {
  light: "#9cd644",
  main: "#84CC16", // Main secondary color
  dark: "#5c8e0f", // Darker shade of the secondary color
  contrastText: "#0a0f0d", // Text color for contrast
};

const SECONDARY = {
  light: "#ef714c",
  main: "#ec4e20", // Main secondary color
  dark: "#a53616", // Darker shade of the secondary color
  contrastText: "#0a0f0d", // Text color for contrast
};

const INFO = {
  lighter: "#D0F2FF",
  light: "#74CAFF",
  main: "#1890FF",
  dark: "#0C53B7",
  darker: "#04297A",
};

const SUCCESS = {
  lighter: "#E9FCD4",
  light: "#AAF27F",
  main: "#54D62C",
  dark: "#229A16",
  darker: "#08660D",
};

const WARNING = {
  lighter: "#FFF7CD",
  light: "#FFE16A",
  main: "#FFC107",
  dark: "#B78103",
  darker: "#7A4F01",
};

const ERROR = {
  lighter: "#FFE7D9",
  light: "#FFA48D",
  main: "#FF4842",
  dark: "#B72136",
  darker: "#7A0C2E",
};

const GREY = {
  0: "#FFFFFF",
  100: "#F9FAFB",
  200: "#F4F6F8",
  300: "#DFE3E8",
  400: "#C4CDD5",
  500: "#919EAB",
  600: "#637381",
  700: "#454F5B",
  800: "#212B36",
  900: "#161C24",
  500_8: alpha("#919EAB", 0.08),
  500_12: alpha("#919EAB", 0.12),
  500_16: alpha("#919EAB", 0.16),
  500_24: alpha("#919EAB", 0.24),
  500_32: alpha("#919EAB", 0.32),
  500_48: alpha("#919EAB", 0.48),
  500_56: alpha("#919EAB", 0.56),
  500_80: alpha("#919EAB", 0.8),
};

const COMMON = {
  common: { black: "#0a0f0d", white: "#f8f8ff" },
  primary: { ...PRIMARY, contrastText: "#0a0f0d" },
  secondary: { ...SECONDARY, contrastText: "#0a0f0d" },
  accent: {
    primary: "#2F3C33",
    onAccent: "#38483D",
    lighter: "#5B7663",
  },
  info: { ...INFO, contrastText: "#fff" },
  success: { ...SUCCESS, contrastText: GREY[800] },
  warning: { ...WARNING, contrastText: GREY[800] },
  error: { ...ERROR, contrastText: "#fff" },
  grey: GREY,
  divider: GREY[400],
  action: {
    hover: GREY[500_8],
    selected: GREY[500_16],
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

// linear-gradient(45deg, #FAFAFA, #D0D0D0)
const LIGHT_MODE_GRADIENT = "#e9ecef";
const DARK_MODE_GRADIENT = "#121212";

const palette = {
  light: {
    ...COMMON,
    mode: "light",
    text: { primary: GREY[800], secondary: GREY[600], disabled: GREY[500] },
    background: {
      paper: "#ffffff",
      default: LIGHT_MODE_GRADIENT,
      neutral: GREY[300],
    },
    action: { active: GREY[600], ...COMMON.action },
  },
  dark: {
    ...COMMON,
    mode: "dark",
    text: { primary: "#fff", secondary: GREY[500], disabled: GREY[600] },
    background: {
      paper: "#252736",
      default: DARK_MODE_GRADIENT,
      neutral: "#36395B",
    },
    action: { active: GREY[500], ...COMMON.action },
  },
};

export default palette;
